import { render, staticRenderFns } from "./SingleSelectItem.vue?vue&type=template&id=f8d6da06&scoped=true&"
import script from "./SingleSelectItem.vue?vue&type=script&lang=js&"
export * from "./SingleSelectItem.vue?vue&type=script&lang=js&"
import style0 from "./SingleSelectItem.vue?vue&type=style&index=0&id=f8d6da06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d6da06",
  null
  
)

export default component.exports